import { render, staticRenderFns } from "./SenderType.vue?vue&type=template&id=1bbbf78e&"
import script from "./SenderType.vue?vue&type=script&lang=js&"
export * from "./SenderType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbbf78e')) {
      api.createRecord('1bbbf78e', component.options)
    } else {
      api.reload('1bbbf78e', component.options)
    }
    module.hot.accept("./SenderType.vue?vue&type=template&id=1bbbf78e&", function () {
      api.rerender('1bbbf78e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/SenderType.vue"
export default component.exports